var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-indicator",class:{
    'status-indicator--online': _vm.online,
    'status-indicator--dev': _vm.dev,
    'status-indicator--hidden': _vm.online && !_vm.dev,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }